import axios from "axios";
import { AUTH_TOKEN_KEY } from "../../constants/localstorageKeys";
import routes from "../../configs/api";

const toggleIsUnlimited = async (packageId) => {
    console.log(packageId, "packageId");
    
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  const URL = `${routes.TOGGLE_ISUNLIMITED}/${packageId}`;

  return new Promise((resolve, reject) => {
    axios
      .patch(
        URL,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default toggleIsUnlimited;
